<ui-wrapper>
  <a [routerLink]="['/']" routerLinkActive="active" class="content">
    <img class="logo" src="./../../../assets/reza-logo.svg" alt="MVCRlogo" />
    <div class="logo-text">
      <div>Registr</div>
      <div>zastupování</div>
    </div>
  </a>
  @if (isTest) {
  <div class="test">TEST</div>
  } @if (user$ | async; as user) {
  <div class="user">
    <!-- {{ user | json }} -->
    <span class="pi pi-user user-icon"></span>
    <h2 class="user-name">
      <span> {{ user.surname | uppercase }} {{ user.name }} </span>
      <span class="ovm"> {{ 'OVM: ' + user.ovmKod }} </span>
      <span role="button" (click)="logout()" class="u-anchor-like logout-link"> Odhlásit </span>
    </h2>
  </div>
  }@else {
  <div class="user">
    <span class="pi pi-user user-icon"></span>
    <h2 class="user-name">
      <span role="button" (click)="login()" class="u-anchor-like logout-link"> Přihlásit se </span>
    </h2>
  </div>
  }
</ui-wrapper>
